import { useState, useEffect } from 'react';

interface VisualViewportState {
    height: number;
    offsetTop: number;
}

function getViewportState(): VisualViewportState {
    const vv = window.visualViewport;
    if (vv) {
        return { height: vv.height, offsetTop: vv.offsetTop };
    }
    return { height: window.innerHeight, offsetTop: 0 };
}

/**
 * Rastrea las dimensiones del visual viewport (área visible real).
 * En móvil, cuando el teclado virtual se abre, `height` se reduce y
 * `offsetTop` puede aumentar. Usarlo en overlays `fixed` para que
 * no queden tapados por el teclado.
 */
export function useVisualViewport(): VisualViewportState {
    const [viewport, setViewport] = useState<VisualViewportState>(getViewportState);

    useEffect(() => {
        const vv = window.visualViewport;
        if (!vv) return;

        function update() {
            setViewport(getViewportState());
        }

        vv.addEventListener('resize', update);
        vv.addEventListener('scroll', update);

        return () => {
            vv.removeEventListener('resize', update);
            vv.removeEventListener('scroll', update);
        };
    }, []);

    return viewport;
}
